import { initializeApp } from "firebase/app"
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyD5dZWQk8mMIClyAdDb-Hcx5PypbbEG9LU",
  authDomain: "qna-live-app.firebaseapp.com",
  projectId: "qna-live-app",
  storageBucket: "qna-live-app.firebasestorage.app",
  messagingSenderId: "439368529869",
  appId: "1:439368529869:web:3bb765cb7d58e1cf267684"
}

const app = initializeApp(firebaseConfig)

export const db = getFirestore(app)
export const auth = getAuth(app)
const provider = new GoogleAuthProvider()

export const signInWithGoogle = () => signInWithPopup(auth, provider)
